import { MicrositeRepository } from "../../../repositories/micrositeRepository"
import { UseCase } from "../../useCase"
import { GetLandingReviewsBySlugRequest } from "./request"
import { GetLandingReviewsBySlugResponse } from "./response"

export class GetLandingReviewsBySlugUseCase
	implements UseCase<GetLandingReviewsBySlugRequest, GetLandingReviewsBySlugResponse>
{
	private _repository

	constructor({ MicrositeRepository }: { MicrositeRepository: MicrositeRepository }) {
		this._repository = MicrositeRepository
	}

	exec({ slug }: GetLandingReviewsBySlugRequest) {
		return this._repository.getLandingReviewsBySlug(slug)
	}
}
